import { ReactElement } from 'react'
import BaseDrawer from '../../../ui-components/modals/BaseDrawer'
import { StoreInfoCard } from './StoreCard'
import { ProductLocationModel } from 'interfaces'
import { useModal, create } from '@ebay/nice-modal-react'
import { ChangeLocationModalData } from '../common/interfaces'

export const StoreSelectorDrawer = create(
  (props: ChangeLocationModalData): ReactElement | null => {
    const modal = useModal()

    const { activeLocation, onChangeLocation, product } = props

    if (!product) {
      return null
    }

    const locations: ProductLocationModel[] = product?.location || []

    const drawerBody = locations.map((loc) => (
      <StoreInfoCard
        key={loc.locationId}
        location={loc}
        selected={
          activeLocation &&
          Number(activeLocation.locationId) === Number(loc.locationId)
        }
        onLocationChange={() => {
          onChangeLocation(loc)
          modal.remove()
        }}
      />
    ))

    return (
      <BaseDrawer
        open={modal.visible}
        title="changeLocation"
        onClose={modal.remove}
        body={drawerBody}
      />
    )
  }
)
